import {
    Card,
    Tabs,
    Button,
    Row,
    Col,
    Divider,
    Typography,
    Space,
    Alert,
    Result,
} from "antd";
import React, { useState, useRef, useEffect } from 'react'
import { DollarOutlined, AppstoreOutlined } from '@ant-design/icons';
import ParticipantRegistrationForm from "./ParticipantRegistrationForm";
import Sessions from "./Sessions";
import AddOns from "./AddOns";
import CouponScreen from "./Coupons";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import api from "libs/api";
import { useCallback } from "react";
import Packages from "./Packages";
const { TabPane } = Tabs;
const { Title, Text } = Typography;


function RegistrationWidget(props = {}) {

    const eventId=props?.data?.event_id
    const {form} = useParams();
    const [activeTab, setActiveTab] = useState('1');
    const participantFormRef = useRef();
    const catalogRef = useRef({ packages: [], sessions: [], addons: [] });
      const [error, setError] = useState(null);

    const [selectedPackages, setSelectedPackages] = useState([]);
    const [selectedSessions, setSelectedSessions] = useState([]);
    const [selectedAddOns, setSelectedAddOns] = useState([]);
    const [couponCode, setCouponCode] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [submissionFailed, setSubmissionFailed] = useState(false);
    const [fullPackDataExist, setFullPackDataExist] = useState(false);

    const [showSuccessScreen, setShowSuccessScreen] = useState(false);

// called this api to get session and package details
    // useCallback to memoize the function and avoid unnecessary re-renders
    const callSessionAndPackageDetails = useCallback(() => {
        setIsLoading(true);
        api.get(`api/portal/participants/event/${eventId}/catalog`)
            .then(([success, response]) => {
                if (success) {
                    setIsLoading(false);
                    let resp = response?.data || {}
                    setFullPackDataExist(resp?.packages && resp?.packages.length>0||resp?.sessions && resp?.sessions.length>0||resp?.addons && resp?.addons.length>0);
                    catalogRef.current = {
                        packages: resp?.packages || [],
                        sessions: resp?.sessions || [],
                        addons: resp?.addons || []
                    };
                    setError(null);
                                 
                    // Handle the response as needed
                } else {
                    setIsLoading(false);
                    setError(response?.message || 'Failed to fetch session and package details');
                    console.error('Failed to fetch session and package details');
                }
            })
            .catch(error => {
                console.error('Error fetching session and package details:', error);
            });
    },[eventId]);

    // useEffect to call the function when the component mounts or eventId changes
    useEffect(() => {
        if (eventId) {
            callSessionAndPackageDetails();
        }
    }, [eventId, callSessionAndPackageDetails]);


    // Function to handle the Next button click
    // This function will handle the logic for moving to the next tab or submitting the form
    const NextButtonClick = () => {
        if (activeTab === '5') {
            // If on the last tab, validate and submit the form
            const data ={
                sessions: selectedSessions?.map(s => s.uuid) || [],
                packages: selectedPackages?.map(p => p.uuid) || [],
                addons: selectedAddOns?.map((item)=> ({quantity: 1, ...item})) || [],
                coupon_code:couponCode,
                event_id: eventId,
                email: participantFormRef.current?.getValues()?.email || "",
                status: 'registered',
            };
            if(data){
                api.post(`api/orders/`, data).then(([success, response]) => {
                    if (success) {
                        setError(null);
                        console.log('Registration submitted successfully:', response);
                        setShowSuccessScreen(true);
                        // Handle successful submission (e.g., show a success message, redirect, etc.)
                        return;
                    } else {
                        setError(response?.message || 'Failed to submit registration, please contact staff admin');
                        setShowSuccessScreen(false);
                        console.error('Failed to submit registration: please contact staff admin', response);
                        return;
                    }
                }).catch(error => {
                    setError(error?.message || 'An error occurred while submitting the registration form');
                    setShowSuccessScreen(false);
                    console.error('Error submitting registration form:', error);
                    return;
                });
            }
            console.log('Submitting registration form with data:', data);
            // Handle final submission logic here
            return;
        }
        if (activeTab === '1') {
            setError(null);
            const isValid = participantFormRef.current?.validate();
            console.log('Form validation result:', isValid);
            if (!isValid) return; // stop if invalid
            let dataChanged = participantFormRef.current?.dataChanged;
            console.log('Submission failed state:', submissionFailed);
            console.log('Data changed state before check:', dataChanged);
            if(submissionFailed) {
                dataChanged = true; // Reset dataChanged state if submission failed
            }
            console.log('Data changed:', dataChanged);
            if(dataChanged ) {

            if(isValid){
                setIsLoading(true);
               const formData = new FormData();
               Object.entries(participantFormRef.current?.getValues() || {}).forEach(([key, value]) => {
                if (Array.isArray(value) && value.length > 0 && value[0]?.originFileObj) {
                    // Multiple or single file upload case
                    value.forEach((file, index) => {
                    if (file.originFileObj) {
                        formData.append(`${key}[${index}]`, file.originFileObj);
                    }
                    });
                } else if (value?.originFileObj) {
                    // Single file object
                    formData.append(key, value.originFileObj);
                } else {
                    // Regular field
                    formData.append(key, value);
                }
                });
                // formData.append('form', form);
                formData.append('status', 'incomplete');
                api.post(`api/form/registration/${form}`, formData)
                .then(([success, response]) => {
                    if (success) {
                        participantFormRef.current.resetDataChanged(); // Reset dataChanged state
                        setSubmissionFailed(false);
                        setIsLoading(false);
                        setError(null);
                        sessionStorage.setItem('participant_registered', JSON.stringify(true));
                        if(!fullPackDataExist){
                            setShowSuccessScreen(true);
                        }
                        setActiveTab('2'); // Switch to session details tab
                    }else {
                        setSubmissionFailed(true);
                        setError(response?.message || 'Failed to submit registration form, please contact staff admin');
                        participantFormRef.current.dataChanged = true; // Reset dataChanged state
                        setIsLoading(false);
                        console.error('Failed to submit registration form: please contact staff admin', response);
                        setActiveTab('1'); // Stay on the registration tab
                    }
                }).catch(error => {
                    setSubmissionFailed(true);
                    setError(error?.message || 'An error occurred while submitting the registration form');
                    setActiveTab('1'); // Stay on the registration tab
                    setIsLoading(false);
                    participantFormRef.current.dataChanged = true; // Reset dataChanged state
                    console.error('Error submitting registration form:', error);
                });
            }
        } else {
            setIsLoading(false);
            // If no changes detected, skip to session details
            setError(null);
            console.log('No changes detected, skipping to session details');
            setActiveTab('2'); // skip to session details if no changes

        }
        return
    }

        // For other tabs, just switch to the next tab
        setActiveTab((prev) => {
            if (prev === '1'){ return '2'; // skip to session details if already registered
            }
            if (prev === '5') return '1'; // loop back to first tab
            return (parseInt(prev) + 1).toString();
        });

    }

    // Function to handle the Previous button click
    const previousButtonClick = () => {
        setActiveTab((prev) => {
            if (prev === '1') return '1'; // loop back to last tab
            return (parseInt(prev) - 1).toString();
        });
    }

    // logic to determine if registration is open or coming soon
    const today = new Date();
    let regDate = new Date(`Fri Aug 29 2025 17:13:39 GMT+0530 (India Standard Time)`)
    const isComingSoon = false

    
    return (

        <Row
  style={{
    margin: "auto",
    padding: 16,
    borderRadius: 12,
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }}
>
  <Col xs={24} sm={24} md={22} lg={20} xl={18} style={{ margin: "0 auto" }}>
    <Card
      bordered={false}
      style={{
        borderRadius: 12,
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        margin: "0 auto",
        maxWidth: "1300px",
        width: "100%",
        background: "rgba(248, 247, 250, 1)"
      }}
      headStyle={{
        borderBottom: "1px solid #f0f0f0",
        padding: "16px 24px",
      }}
    >
        {showSuccessScreen ? (
            <div style={{ padding: 24,height: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <Result
                status="success"
                title="Registration Successful!"
                subTitle="Thank you for registering. We have received your details successfully."
                />
            </div>
                    )
      :(
      
        isComingSoon ? (
          <div style={{ padding: 24,height: '400px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <Result 
                status="info"
                title="Registration Coming Soon!"
                subTitle={`The registration will open at ${regDate.toLocaleTimeString()}. Please check back later.`}
            />
          </div>
        ) : (
      
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        tabBarGutter={16}
        style={{ marginBottom: 24, minHeight: "400px" }}
        tabBarStyle={{ paddingLeft: 8, flexWrap: "wrap" }} // allow wrapping
      >
        <TabPane disabled key="1" tab={<Title level={5}>Participant Details</Title>}>
          <ParticipantRegistrationForm
            {...props}
            ref={participantFormRef}
            isLoading={isLoading}
          />
        </TabPane>
        {fullPackDataExist&&<>
            <TabPane
          disabled
          key="2"
          tab={<Title level={5}>Packages</Title>}
        >
          <Packages
            {...props}
            sessionData={catalogRef.current.sessions}
            packageData={catalogRef.current.packages}
            selectedPackages={selectedPackages}
            setSelectedPackages={setSelectedPackages}
            selectedSessions={selectedSessions}
            setSelectedSessions={setSelectedSessions}
            selectedAddOns={selectedAddOns}

          />
        </TabPane>
        <TabPane
          disabled
          key="3"
          tab={<Title level={5}>Sessions</Title>}
        >
          <Sessions
            {...props}
            sessionData={catalogRef.current.sessions}
            packageData={catalogRef.current.packages}
            selectedPackages={selectedPackages}
            selectedSessions={selectedSessions}
            setSelectedSessions={setSelectedSessions}
            selectedAddOns={selectedAddOns}
          />
        </TabPane>
        <TabPane
          disabled
          key="4"
          tab={<Title level={5}>Add Ons</Title>}
        >
          <AddOns
            {...props}
            addOnData={catalogRef.current.addons}
            selectedAddOns={selectedAddOns}
            setSelectedAddOns={setSelectedAddOns}
            selectedPackages={selectedPackages}
            selectedSessions={selectedSessions}
          />
        </TabPane>
        <TabPane
          disabled
          key="5"
          tab={<Title level={5}>Coupons</Title>}
        >
          <CouponScreen
            {...props}
            selectedPackages={selectedPackages}
            selectedSessions={selectedSessions}
            selectedAddOns={selectedAddOns}
            setCouponCode={setCouponCode}
          />
        </TabPane>
        </>
        }
      </Tabs>)
    )}

      {error && (
        <Alert
          message={error}
          type="error"
          closable
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <Divider />

      {(!showSuccessScreen&&!isComingSoon)&&<Row justify="end" style={{ padding: "0 24px" }}>
        <Space>
          <Button
            style={{
              backgroundColor: "#b7322c",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "0 24px",
            }}
            disabled={activeTab === "1"}
            onClick={previousButtonClick}
          >
            Previous
          </Button>

          <Button
            style={{
              backgroundColor: "#b7322c",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "0 24px",
            }}
            loading={isLoading}
            onClick={NextButtonClick}
          >
            {(activeTab === "5"||!fullPackDataExist) ? "Submit" : "Next"}
          </Button>
        </Space>
      </Row>}
    </Card>
  </Col>
</Row>


    )
}

export default RegistrationWidget